<template>
  <div style="height: 200px">
    <loader />
  </div>
</template>
<script>
import Loader from '../Loader.vue';
import { ACTION_AWAIT_REQUEST } from '../../store/action-types';
import axios from 'axios';
import {
  SHOPWARE_SHOP_ID,
  SHOPWARE_BASE_URL
} from '../../../utils/configure-environment';
import Cookies from 'js-cookie';
import { MUTATION_COMPOSITION_SET_COMPOSITION } from '../../store/modules/composition/mutation-types';

export default {
  name: 'BasketLoader',
  components: {
    Loader
  },
  async mounted() {
    let articleNumber;
    await this.$store.dispatch(ACTION_AWAIT_REQUEST, async () => {
      const csrfToken = Cookies.get('__csrf_token-' + SHOPWARE_SHOP_ID);

      const response = await axios.post(
        `${SHOPWARE_BASE_URL}/LoadBasketItem/ajaxLoadArticle/BasketItem/${this.$route.params.basketItemId}`,
        [],
        {
          headers: {
            'X-CSRF-Token': csrfToken
          }
        }
      );

      articleNumber = response.data.article_number;

      const composition = JSON.parse(response.data.shr_composition);
      this.$store.commit(MUTATION_COMPOSITION_SET_COMPOSITION, composition);
    });
    this.$router.push({
      name: 'root',
      params: { articleNumber: articleNumber }
    });
  }
};
</script>
